import {combineReducers} from 'redux';
import Home from "./home";
export default combineReducers({
    Home,
});